import React from 'react';

const TrendingProducts = ({ products }) => {
    if (products.length && products.length === 0) {
        return <></>
    } else {
        return (
            <div className="max-w-7xl mx-auto px-4 py-8">
                <h2 className="text-2xl font-bold mb-6 text-center">Top Performing Products</h2>
                {/* Scrollable Horizontal Container */}
                <div className="overflow-x-auto whitespace-nowrap pb-10">
                    <div className="flex gap-6">
                        {products.map((product) => (
                            <div
                                key={product.id}
                                className="bg-white shadow-md rounded-lg overflow-hidden hover:shadow-lg transition-shadow flex-shrink-0 w-64"
                            >
                                {/* Product Image */}
                                <div className="relative">
                                    <img
                                        src={product.imageUrl}
                                        alt={product.name}
                                        className="w-full h-48 object-cover"
                                    />
                                    {product.isTrending && (
                                        <span className="absolute top-2 right-2 bg-red-500 text-white text-xs font-semibold px-2 py-1 rounded-full">
                                            Trending
                                        </span>
                                    )}
                                </div>

                                {/* Product Details */}
                                <div className="p-4">
                                    <h3 className="text-lg font-semibold text-gray-800 truncate">
                                        {product.name}
                                    </h3>
                                    <p className="text-sm text-gray-600 mt-1 line-clamp-3">{product.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
};

export default TrendingProducts;
